import { createSlice } from '@reduxjs/toolkit'
import { format, getUnixTime, parseISO } from "date-fns";
import _ from "lodash";

export const initiativeSlice = createSlice({
    name: 'initiative'
    ,initialState: {
        initiative : false
        ,access : false
    }
    ,reducers : {
        SetInitiative : (state, action) => {
            console.log('calling reducer initiative', getUnixTime(new Date()), action);

            if(action.payload === false)
            {
                state.initiative = false;
            }
            else
            {
                state.initiative = _.assignIn({}, action.payload , {
                    
                }) ;
            }

        }
        ,SetInitiativeAccess : (state, action) => {
            console.log('calling reducer initiative access', getUnixTime(new Date()), action);
            state.access = action.payload;
        }
    }
});

export default initiativeSlice.reducer;